if (!customElements.get('up-announcement-countdown')) {
  class upAnnouncementCountdown extends HTMLElement {
    constructor() {
      super();

      if(this.dataset.startDate){
        this.startDate = new Date(this.dataset.startDate).getTime();
        this.endDate = new Date(this.dataset.endDate).getTime();
      }else if (this.dataset.startDaily){
        const currentDate = new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().substring(0, 10);
        this.startDate = new Date(`${currentDate}T${this.dataset.startDaily}`).getTime();
        this.endDate = new Date(`${currentDate}T${this.dataset.endDaily}`).getTime();
      }

      this.state = null;

      this.second = 1000;
      this.minute = this.second * 60;
      this.hour = this.minute * 60;
      this.day = this.hour * 24;

      // UI
      this.messages = Array.from(this.querySelectorAll('span[state]'));
      this.countdown = this.querySelector('.announcement-bar__countdown-wrapper');
      this.countdownDigits = {
        days: this.countdown.querySelector('[data-days]'),
        hours: this.countdown.querySelector('[data-hours]'),
        minutes: this.countdown.querySelector('[data-minutes]'),
        seconds: this.countdown.querySelector('[data-seconds]'),
      };
    }

    connectedCallback() {
      this.updateComponent();
      this.timer = setInterval(this.updateComponent.bind(this), 1000);
    }

    updateComponent() {
      this.updateState();
      if (this.state != this.lastState) this.updateView();
      if (this.state === 'during') this.updateCounter();
      if (this.state === 'after') clearInterval(this.timer);
    }

    updateState() {
      this.lastState = this.state;
      if (new Date().getTime() - this.startDate > 0) {
        this.state = this.endDate - new Date().getTime() > 0 ? 'during' : 'after';
      } else {
        this.state = 'before';
      }
    }

    updateView() {
      // Message
      this.messages.forEach((message) => message.classList.add('hidden'));
      this.messages.find((message) => message.getAttribute('state') === this.state).classList.remove('hidden');
      // Coutdown
      this.state === 'during' ? this.countdown.classList.remove('hidden') : this.countdown.classList.add('hidden');
      if (
        this.state === 'after' &&
        this.messages.find((message) => message.getAttribute('state') === 'after').textContent === ''
      ) {
        (this.closest('.utility-bar--bottom-border') || this).classList.add('hidden');
      }
    }

    updateCounter() {
      const t = this.endDate - new Date().getTime();

      if (this.countdownDigits.days)
        this.countdownDigits.days.innerText = String(Math.floor(t / this.day)).padStart(2, '0');
      this.countdownDigits.hours.innerText = String(Math.floor((t % this.day) / this.hour)).padStart(2, '0');
      this.countdownDigits.minutes.innerText = String(Math.floor((t % this.hour) / this.minute)).padStart(2, '0');
      this.countdownDigits.seconds.innerText = String(Math.floor((t % this.minute) / this.second)).padStart(2, '0');
    }
  }
  customElements.define('up-announcement-countdown', upAnnouncementCountdown);
}
